import isStorageAvailable from './is-storage-available'
import logger from './logger'

/**
 * Creates a named option object, that can be written, read and removed from the local storage.
 *
 * @param {String} storageKey The unique name for this option.
 */
function Option(storageKey) {
  this.storageKey = storageKey
}

Option.prototype.getStorage = function() {
  if (!isStorageAvailable('localStorage')) {
    return
  }

  try {
    return JSON.parse(localStorage.getItem(this.storageKey)) || {}
  } catch (error) {
    logger('could not get option', { error })

    return {}
  }
}

Option.prototype.get = function(key) {
  if (!key) {
    throw new ReferenceError('key is not defined')
  }

  if (!isStorageAvailable('localStorage')) {
    return
  }

  var storage = this.getStorage()
  return storage[key]
}

Option.prototype.set = function(key, value) {
  if (!key) {
    throw new ReferenceError('key is not defined')
  }

  if (key.constructor !== String) {
    throw new TypeError('key must be a string')
  }

  if (!isStorageAvailable('localStorage')) {
    return
  }

  var storage = this.getStorage()
  storage[key] = value

  try {
    localStorage.setItem(this.storageKey, JSON.stringify(storage))
  } catch (error) {
    logger('could not set option', { key, value, error })
  }
}

Option.prototype.delete = function(key) {
  if (!isStorageAvailable('localStorage')) {
    return
  }

  var storage = this.getStorage()
  delete storage[key]

  try {
    localStorage.setItem(this.storageKey, JSON.stringify(storage))
  } catch (error) {
    logger('could not delete option', { key, error })
  }
}

export default Option
